export const visit = (vm, at) => {
vm(require("foundations-components/lang/de.lyaml"));
at({ "de": { "placeholder": "Platzhalter" } });
};